import { render, staticRenderFns } from "./AddNewCompany.vue?vue&type=template&id=7cac4d2b&scoped=true&"
import script from "./AddNewCompany.vue?vue&type=script&lang=js&"
export * from "./AddNewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cac4d2b",
  null
  
)

export default component.exports